import { render, staticRenderFns } from "./SkillStatements.vue?vue&type=template&id=5547bdb6&scoped=true"
import script from "./SkillStatements.vue?vue&type=script&lang=js"
export * from "./SkillStatements.vue?vue&type=script&lang=js"
import style0 from "./SkillStatements.vue?vue&type=style&index=0&id=5547bdb6&prod&scoped=true&lang=scss"
import style1 from "./SkillStatements.vue?vue&type=style&index=1&id=5547bdb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547bdb6",
  null
  
)

export default component.exports